module.exports = __webpack_public_path__ + "static/media/etbi.75554a04.png";